import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeModule } from 'src/app/@theme/theme.module';
import { IframeModalRenderComponent } from './iframe-modal-render.component';

const COMPONENTS = [
    IframeModalRenderComponent
];

@NgModule({
    imports: [CommonModule, ThemeModule, ...COMPONENTS],
    exports: [...COMPONENTS]
})
export class IframeModalModule { }